import axios, { AxiosInstance, CreateAxiosDefaults, InternalAxiosRequestConfig } from 'axios';
import useAuthData from '../../../customHooks/useAuthData';

const onRequest = () => async (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
  if (config && !Object.prototype.hasOwnProperty.call(config.headers, 'Authorization')) {
    const { token } = useAuthData();
    config.headers.set('Authorization', `Bearer ${token}`);
  }
  return config;
};

export const createAxiosInstance = (config?: CreateAxiosDefaults): AxiosInstance => {
  const instance = axios.create({ ...config, allowAbsoluteUrls: false });

  instance.interceptors.request.use(onRequest());

  return instance;
};
